import { ArrowDown } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Set It Up",
    desc: "Install your Pickle Wall training system on a suitable training surface.",
  },
  {
    n: "02",
    title: "Hold The Line",
    desc: "Use the ATP ZONE and kitchen-line markers to create purposeful repetition.",
  },
  {
    n: "03",
    title: "Get Your Reps",
    desc: "Train independently, work through drills, and build consistency through repetition.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="relative py-24 md:py-36 bg-[#070707] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-4">
            The Process
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-balance">
            Your Wall. Your Court. Your Reps.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className="group relative bg-[#0f0f0f] border border-white/5 rounded-3xl p-8 md:p-10 hover:border-[#FF6B00]/40 transition-all overflow-hidden"
            >
              <div className="absolute -right-6 -top-6 text-[140px] font-display font-black text-white/[0.03] leading-none">
                {s.n}
              </div>
              <div className="relative">
                <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00]">
                  Step {s.n}
                </div>
                <h3 className="mt-4 font-display text-3xl md:text-4xl font-bold uppercase tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-white/65 leading-relaxed">{s.desc}</p>
                {i < steps.length - 1 && (
                  <ArrowDown
                    size={20}
                    className="mt-6 text-[#FF6B00]/60 md:hidden"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
